import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, Transition as _Transition, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "v-confirm-modal__buttons" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M7.78935 1.01488C7.38899 0.500134 6.61101 0.500136 6.21065 1.01488L0 9L14 9L7.78935 1.01488Z",
  fill: "white"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

import { useConfirmModal } from '@/stores/confirm-modal';
import { useKeyDownStore } from '@/stores/key-down';
import { CSSProperties, ref, watch } from 'vue';
import VButton from './VButton.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TheConfirmModal',
  setup(__props) {

const pending = ref(false)
const store = useConfirmModal()

const style = ref<CSSProperties>({})
const svgStyle = ref<CSSProperties>({})

const calcStyle = () => {
  if (!store.options?.anchorEl) return
  const rect = store.options.anchorEl.getBoundingClientRect()
  if (mode === "bottom") {
    style.value = {
      top: rect.bottom + 10 + "px",
      right: window.innerWidth - rect.right + "px",
      transformOrigin: "top right"
    }
    svgStyle.value = {
      right: rect.width/2-7,
      top: -9
    }
  }
  if (mode === "top") {
    style.value = {
      bottom: window.innerHeight - rect.top + 10 + "px",
      right: window.innerWidth - rect.right + "px",
      transformOrigin: "bottom right"
    }
    svgStyle.value = {
      right: rect.width/2-7,
      bottom: -9,
      transform: `rotate(180deg)`
    }
  }

}
watch(() => store.options, () => {
  calcStyle()
})

let mode = "bottom"
const modalRef = ref<HTMLElement>()
watch(() => store.opened, () => {
  if (!modalRef.value) return
  const rect = modalRef.value.getBoundingClientRect()
  if (rect.top + rect.height > window.innerHeight - 10) {
    mode = "top"
    calcStyle()
  } 
}, { flush: "post" })

watch(() => store.opened, (value) => {
  if (value === true) {
    pending.value = false
  }
  if (value === false) {
    mode = "bottom"
  }
})

const confirm = () => {
  if (!store.options?.onConfirm) return
  const resp = store.options.onConfirm()
  if (typeof resp === "object" && "then" in resp) {
    pending.value = true
    resp.then(() => {
      pending.value = false
      store.close()
    }).catch(() => {
      pending.value = false
    })
  } else {
    store.close()
  }
}

useKeyDownStore().watch("Escape", () => store.opened, () => {
  store.close()
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_unref(store).opened)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "v-select-backdrop",
          style: {"z-index":"1104"},
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(store).close && _unref(store).close(...args)))
        }))
      : _createCommentVNode("", true),
    _createVNode(_Transition, { name: "grow" }, {
      default: _withCtx(() => [
        (_unref(store).opened)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              ref_key: "modalRef",
              ref: modalRef,
              class: "v-confirm-modal",
              style: _normalizeStyle(style.value)
            }, [
              _createTextVNode(_toDisplayString(_unref(store).options?.title ?? "Are you sure you would like to delete the Replies set?") + " ", 1),
              _createElementVNode("div", _hoisted_1, [
                _createVNode(VButton, {
                  disabled: pending.value,
                  onClick: confirm
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Confirm")
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(VButton, {
                  secondary: "",
                  onClick: _unref(store).close
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Cancel")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              (_openBlock(), _createElementBlock("svg", {
                width: "14",
                height: "9",
                viewBox: "0 0 14 9",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                style: _normalizeStyle(svgStyle.value)
              }, _hoisted_3, 4))
            ], 4))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})